// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonRunningPlan_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.9997 8.00036C13.9997 11.314 11.3135 14.0002 7.99987 14.0002C5.02697 14.0002 2.55908 11.838 2.08301 9.00033H0.0620098C0.554093 12.9465 3.92038 16.0001 7.99987 16.0001C12.418 16.0001 15.9996 12.4185 15.9996 8.00036C15.9996 3.92087 12.946 0.554581 8.99984 0.0624981V2.0835C11.8375 2.55956 13.9997 5.02746 13.9997 8.00036Z" class="svg-bg"/>
  <path d="M6.9999 2.0835V.0624981C5.53932.24463 4.20102.820504 3.09457 1.68055L4.52364 3.10962C5.24651 2.5949 6.08836 2.23643 6.9999 2.0835ZM3.10942 4.52374 1.68036 3.09468C.820148 4.2012.244163 5.53964.0620099 7.00039H2.08301C2.23597 6.08868 2.59454 5.24669 3.10942 4.52374ZM2.33478 2.3521 2.35162 2.33527C2.346 2.34087 2.34039 2.34648 2.33478 2.3521Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonRunningPlan is a generated icon component.
 */
let IconCommonRunningPlan = IconCommonRunningPlan_1 = class IconCommonRunningPlan extends IconBaseElement {
    render() {
        return html `${IconCommonRunningPlan_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonRunningPlan.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonRunningPlan = IconCommonRunningPlan_1 = __decorate([
    customElement('zui-icon-common-running-plan')
], IconCommonRunningPlan);
export { IconCommonRunningPlan };
